module.exports = __webpack_public_path__ + "static/mobility-cbbf9a4273355437553b62554b6f0e19.jpg";